import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import { Icon } from '@aoworld-aotech/components-react';

const ColourSwatch = ({
	name: facetType,
	facetValue,
	index,
	handleChange,
	facetPosition,
}) => {
	const colourSwatchRef = useRef(null);
	const [tickColour, setTickColour] = useState('ui-light-contrast');

	useEffect(() => {
		if (!colourSwatchRef.current) {
			return;
		}

		const { backgroundColor } = getComputedStyle(colourSwatchRef.current);

		if (!backgroundColor) {
			return;
		}

		const rgb = backgroundColor.match(/\d+/g);

		// http://www.w3.org/TR/AERT#color-contrast
		const brightness = Math.round(
			(parseInt(rgb[0], 10) * 299 +
				parseInt(rgb[1], 10) * 587 +
				parseInt(rgb[2], 10) * 114) /
				1000
		);

		if (brightness < 125) {
			setTickColour('ui-dark-contrast');
		}
	}, []);

	if (!facetValue || !handleChange) {
		return null;
	}

	const { FriendlyName, Name, Total, Selected } = facetValue;

	return (
		<label
			className="checkbox flex checkbox-inherit-text flex"
			aria-label="Choose color swatch">
			<input
				name={facetType}
				data-testid="colour-swatch-input"
				data-aods="checkbox"
				type="checkbox"
				className="checkbox_input"
				value={Name}
				data-tag-name="Colour swatch facet"
				data-tag-valueName={Name}
				data-tag-sidebarInteractionType="facetInteraction"
				data-tag-exposedFacet=""
				data-tag-facetPosition={`${facetPosition + 1}_${index + 1}`}
				data-tag-pageTitle={document.title}
				data-tag-pagePath={window.location.pathname}
				onChange={(evt) => handleChange(evt, facetValue, index)}
			/>
			<span className="checkbox_body rounded-b-none px-4 py-2 md:py-1 hover:bg-lightblue">
				<span
					className={classnames('p-1', {
						'border border-ui-highlight-accent border-solid rounded-full':
							Selected,
					})}>
					<span
						ref={colourSwatchRef}
						className={classnames(
							'facet-type__colour-swatch align-middle h-6 inline-block rounded-full w-6 flex items-center justify-center',
							FriendlyName
						)}>
						{Selected && (
							<Icon
								icon="tick"
								size="lg"
								className={`facet-type__colour-swatch-tick text-${tickColour}`}
							/>
						)}
					</span>
				</span>
				<span className="checkbox_label m-auto">
					<div
						className={classnames('flex justify-between', {
							'text-ui-highlight-accent': Selected,
						})}>
						<div>{Name}</div>
						<div>({Total})</div>
					</div>
				</span>
			</span>
		</label>
	);
};

export default ColourSwatch;
